<template>
  <div id="main-bandaid">
    <div id="bandaid">
      <a href="#" class="bandaid-sign-plus" @click="click">+</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "BandAid",
  data() {
    return {};
  },
  methods: {
    click(e) {
      e.preventDefault();
      this.$emit("click");
    }
  }
};
</script>
<style scoped>
#main-bandaid {
  float: right;
}
.bandaid-sign {
  line-height: normal;
  display: inline;
  font-size: 1.5em;
  margin-right: 0.5em;
  margin-left: 0.5em;
  text-decoration: none;
  color: #0D6496 !important;
}
.bandaid-sign-plus {
  line-height: normal;
  display: inline;
  font-size: 1.5em;
  text-decoration: none;
  color: #0D6496 !important;
}
.bandaid-sign-plus:hover {
  font-weight: 900;
}
.bandaid-sign-neg:hover {
  font-weight: 900;
}
.bandaid-sign-neg {
  line-height: normal;
  display: inline;
  font-size: 1.5em;
  text-decoration: none;
  color: #0D6496 !important;
}
#bandaid-amount {
  color: #0D6496 !important;
  font-weight: 600;
  display: inline;
}
#bandaid {
  /* vertical-align: middle; */
  border-radius: 25px;
  border: 1px solid #0D6496 !important;
  color: #0D6496 !important;
  width: 6em;
  /* margin: 0 auto; */
}
</style>



// WEBPACK FOOTER //
// src/Components/BandAidForAdditionals.vue